const FeatureEndpoints = {
  getFeatureStatus: {
    method: 'GET',
    url: (featureName: string) => `/features/status/${featureName}`,
  },
  getFeatureConfigs: {
    method: 'GET',
    url: `/features/feature-configs`,
  },
  useFeature: {
    method: 'POST',
    url: '/features/use-feature',
  },
} as const;

// Create type from the object
type FeatureEndpoints = typeof FeatureEndpoints;

export type { FeatureEndpoints };
export default FeatureEndpoints;
